import { render, staticRenderFns } from "./ThumbnailItem.vue?vue&type=template&id=88909206&scoped=true&"
import script from "./ThumbnailItem.vue?vue&type=script&lang=js&"
export * from "./ThumbnailItem.vue?vue&type=script&lang=js&"
import style0 from "./ThumbnailItem.vue?vue&type=style&index=0&id=88909206&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88909206",
  null
  
)

export default component.exports